var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthCard',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"title":"Login","submit-text":"Sign in"},on:{"click-submit":_vm.login},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('router-link',{attrs:{"to":{
      name: _vm.routeNames.verifyIdentity,
      query: { forgotPassword: true }
    }}},[_vm._v(" Forgot Password? ")]),_c('router-link',{attrs:{"to":{
      name: _vm.routeNames.verifyIdentity,
      query: { register: true } }}},[_vm._v(" Register ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }